module.exports = __webpack_public_path__ + "img/kurume.920a9fbf.png";